module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qmusc18-fd1a19ff5f9a755393f4c58706b4ea49.jpg";